<script setup>
import { defineEmits, defineProps, onMounted, ref, watch } from "vue"
import RatingSkillsTableMobile from "./Mobile/RatingSkillsTableMobile.vue";
import RatingSkillsTableWeb from "./Web/RatingSkillsTableWeb.vue";
import { KNOLIA } from "../knolia";
import { Gems } from "../gems";
import RatingTypeSearch from "../enums/RatingTypeSearch";
import BaseSelect from "./BaseSelect.vue";

const emits = defineEmits(['update-filter-by-job', 'update-selected-ddl', 'update-rank-type'])
const props = defineProps({
  ratingSkillsModal: { type: Object, required: true },
  rating: { type: Object, required: true }
})
const ddlDepth = ref([])
const userFunction = ref('')
const filter = ref("")
const filterByJob = ref(true)

async function GetDepthDDL() {
  const res = await KNOLIA.CallBackEnd("get", "get-depth-ddl")
  ddlDepth.value = res.data.ddl_depth
  userFunction.value = res.data.user_function
}

watch(filterByJob, (newValue) => {
  emits('update-filter-by-job', newValue)
  props.rating.GetRatingSkills(filter.value)
})

onMounted(async () => {
  await GetDepthDDL()
})

</script>

<template>
  <div>
    <div class="div-user-sitemap fw-bold">
      <!-- <span @click="$router.push('/my-knolia')" class="cursor-pointer">Meu Knolia</span>
      <i class="bi bi-arrow-right"></i> -->
      <span>Classificar/Atualizar Competências</span>
    </div>

    <div class="row gx-2 gy-2 align-items-center mb-4 w-100 m-0">
      <div class="col-6 col-sm-6 col-md-6 col-lg-2 p-0 pe-2 m-0">
        <base-select :value="`${props.rating.selectedDDL.value}`" @change="emits('update-selected-ddl', $event.target.value)">
          <option value="null">Filtrar por...</option>
          <option v-for="elem in ddlDepth" :key="elem.id" :value="elem.id"> {{ elem.designation }}</option>
        </base-select>
      </div>

      <div class="col-6 col-sm-6 col-md-6 col-lg-2 p-0 m-0 pe-md-2 pe-lg-2">
        <base-select :value="props.rating.rankType.value" @change="emits('update-rank-type', $event.target.value)">
          <option :value="RatingTypeSearch.ALL">Todas</option>
          <option :value="RatingTypeSearch.RANKED">Classificadas</option>
          <option :value="RatingTypeSearch.UNRANKED">Não classificadas</option>
          <option :value="RatingTypeSearch.NON_VALIDATED">Validação solicitada</option>
          <option :value="RatingTypeSearch.VALIDATED">Com validação</option>
        </base-select>
      </div>

      <div class="col-11 col-sm-11 col-md-11 col-lg-3 p-0 mt-2 mt-lg-0">
        <input class="search-elem w-100" :class="{'ddl-alt-padding': rating.isMobile.value || rating.isLowerThanMobile.value}"
         placeholder="Procurar..." type="text" v-model="filter" />
      </div>

      <div class="col-1 col-lg-auto d-flex justify-content-center mt-2 mt-lg-0 p-0 ps-md-4 pe-sm-4 pe-md-4 m-0">
        <i class="bi bi-search fs-4" role="button" @click="rating.GetRatingSkills(filter)"></i>
      </div>
      
      <div class="col-12 col-lg-auto d-flex p-0 mt-2 mt-lg-0 gap-2 ms-auto">
        <label @mouseenter="Gems.Tooltip($event.target, userFunction, 'tooltip')">Filtrar pela minha função</label>
        <input type="checkbox" class="cursor-pointer chk-filter-by-job" v-model="filterByJob"/>
      </div>
    </div>

    <component
      :is="rating.isMobile.value || rating.isLowerThanMobile.value ? RatingSkillsTableMobile : RatingSkillsTableWeb"
      :rating-data="rating" :rating-skills-modal="props.ratingSkillsModal"
    />
  </div>
</template>

<style scoped>

.search-elem {
  width: 40%;
}

.chk-filter-by-job {
  transform: scale(1.5);
  margin-left: 5px;
}

.div-user-sitemap {
  display: flex;
  gap: 5px;
  padding: 0px 0px 15px 0px;
  font-size: 1.5em;
}

@media only screen and (max-width: 1300px) {

  .search-elem {
    width: 25%;
  }

  .div-user-sitemap {
    padding: 0px 0px 10px 0px;
  }

}
</style>
